export const NAV_DATA = [
	{ id: 1, name: "start", path: "/", exact: "true" }, // exact: true  exact={link.exact ? link.exact : false}
	{ id: 2, name: "ogłoszenia", path: "/ogloszenia" },
	{ id: 3, name: "intencje", path: "/intencje" },
	{ id: 4, name: "nabożeństwa", path: "/nabozenstwa" },
	{ id: 5, name: "powołania", path: "/powolania" },
	{ id: 6, name: "duszpasterze", path: "/duszpasterze" },
	// { id: 7, name: "transmisja Mszy Św.", path: "/transmisja" },
	{ id: 8, name: "regulamin cmentarza", path: "/regulamin" },
];
